module.exports = __webpack_public_path__ + "static/img/about_zhuzq05.c137dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_zhuzq05.png
// module id = JnRc
// module chunks = 1